import RepositoryFactory from '@/repository/RepositoryFactory';
import { PutShiftCategoriesOrderRequest, ResponseShiftCategory } from '@/model/repository';
import { compareShiftCategoricalItem } from '@/service/shift/categoryComparator';
const shiftServiceRepositories = RepositoryFactory.shiftService;

/**
 * シフトカテゴリを並び替え
 */
export async function updateShiftCategoriesOrder(payload: PutShiftCategoriesOrderRequest) {
  const updatedShiftCategoriesOrder = await shiftServiceRepositories.shiftCategoriesOrder.update(payload);
  return updatedShiftCategoriesOrder.data;
}

export const sortShiftCategories = (shiftCategories: ResponseShiftCategory[]) => {
  const categoryMapper = (shiftCategory: ResponseShiftCategory) => ({
    id: shiftCategory.shiftCategoryId,
    ...shiftCategory,
  });
  shiftCategories.sort((a, b) => compareShiftCategoricalItem(categoryMapper(a), categoryMapper(b)));
};
